/** InsCoder 2026-09-17 B + HP 26 brand brief: award footnote (PC hover bubble / MB tap modal) **/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-hp26-bb]';
  var TRIGGER_SELECTOR = '[data-hp26-bb-trigger]';
  var TIP_SELECTOR = '.hp_26_bb__tip';
  var MODAL_SELECTOR = '[data-hp26-bb-modal]';
  var CLOSE_SELECTOR = '[data-hp26-bb-close]';
  var MOBILE_QUERY = '(max-width: 989px)';
  var TIP_GUTTER = 16;
  // The arrow apex is pinned to 90% of the bubble width (10% from its right edge).
  var ARROW_LEFT_RATIO = 0.9;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  /** InsCoder 2026-09-18 B + Positions the bubble so its arrow (pinned at 90% of the bubble
      width) lands exactly on the award icon: shift the whole bubble left by the arrow's offset
      from centre instead of moving the arrow itself. **/
  function positionTip(root, tip, trigger) {
    var tipWidth = tip.offsetWidth;
    if (!tipWidth) return;

    var rootRect = root.getBoundingClientRect();
    var triggerRect = trigger.getBoundingClientRect();
    var half = tipWidth / 2;
    var center = triggerRect.left + triggerRect.width / 2 - rootRect.left;
    // The arrow apex sits 40% of the width to the right of the bubble centre.
    var x = center - (ARROW_LEFT_RATIO - 0.5) * tipWidth;

    if (tipWidth + TIP_GUTTER * 2 >= rootRect.width) {
      x = rootRect.width / 2;
    } else {
      if (x - half < TIP_GUTTER) x = TIP_GUTTER + half;
      if (x + half > rootRect.width - TIP_GUTTER) x = rootRect.width - TIP_GUTTER - half;
    }

    tip.style.setProperty('--hp26-bb-tip-x', x + 'px');
    tip.style.setProperty('--hp26-bb-tip-y', triggerRect.bottom - rootRect.top + 'px');
  }
  /** InsCoder 2026-09-18 E + Positions the bubble so its arrow (pinned at 90% of the bubble
      width) lands exactly on the award icon: shift the whole bubble left by the arrow's offset
      from centre instead of moving the arrow itself. **/

  /** InsCoder 2026-09-18 B + Count-up: once the section scrolls into view, each figure's number
      animates from 0 up to its target. Any prefix / suffix around the number ("M+", "+", …) is
      preserved, so "6M+" runs 0 -> 6 and ends as "6M+". **/
  function initCounters(root) {
    if (!('IntersectionObserver' in window)) return;

    var els = root.querySelectorAll('.hp_26_bb__stat-value');
    var items = [];

    els.forEach(function (el) {
      var text = el.textContent.trim();
      var m = text.match(/^([^0-9]*)([0-9]+)([\s\S]*)$/);
      if (!m) return;

      var target = parseInt(m[2], 10);
      if (!target) return;

      var prefix = m[1];
      var suffix = m[3];
      el.textContent = prefix + '0' + suffix;
      items.push({ el: el, prefix: prefix, target: target, suffix: suffix });
    });

    if (!items.length) return;

    var DURATION = 1200;

    function run() {
      var start = null;
      function frame(now) {
        if (start === null) start = now;
        var progress = Math.min((now - start) / DURATION, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        items.forEach(function (item) {
          var value = Math.round(item.target * eased);
          item.el.textContent = item.prefix + value + item.suffix;
        });
        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          items.forEach(function (item) {
            item.el.textContent = item.prefix + item.target + item.suffix;
          });
        }
      }
      requestAnimationFrame(frame);
    }

    var started = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !started) {
          started = true;
          observer.disconnect();
          run();
        }
      });
    }, { threshold: 0.4 });

    observer.observe(root);
  }
  /** InsCoder 2026-09-18 E + Count-up: once the section scrolls into view, each figure's number
      animates from 0 up to its target. Any prefix / suffix around the number ("M+", "+", …) is
      preserved, so "6M+" runs 0 -> 6 and ends as "6M+". **/
      

  function initSection(root) {
    if (!root || root.dataset.hp26BbReady === 'true') return;
    root.dataset.hp26BbReady = 'true';

    initCounters(root);

    var trigger = root.querySelector(TRIGGER_SELECTOR);
    if (!trigger) return;

    var tip = root.querySelector(TIP_SELECTOR);
    var modal = root.querySelector(MODAL_SELECTOR);

    /** InsCoder 2026-09-17 B + Desktop: the bubble follows the icon box **/
    if (tip) {
      trigger.addEventListener('pointerenter', function () {
        if (isMobile()) return;
        positionTip(root, tip, trigger);
      });

      trigger.addEventListener('focus', function () {
        if (isMobile()) return;
        positionTip(root, tip, trigger);
      });
    }
    /** InsCoder 2026-09-17 E + Desktop: the bubble follows the icon box **/

    /** InsCoder 2026-09-17 B + Mobile: the icon opens the footnote modal **/
    if (modal) {
      var closeModal = function () {
        if (modal.hidden) return;
        modal.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        // 'overflow-hidden' on <body> is the theme-wide scroll lock (theme.css)
        document.body.classList.remove('overflow-hidden');
        trigger.focus();
      };

      var openModal = function () {
        if (!modal.hidden) return;
        modal.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
        // The mask also carries the close hook, so target the button itself for the initial focus
        var closeBtn = modal.querySelector('.hp_26_bb__modal-close');
        if (closeBtn) closeBtn.focus();
      };

      trigger.addEventListener('click', function () {
        if (!isMobile()) return;
        if (modal.hidden) openModal();
        else closeModal();
      });

      // The mask and the X both carry the close hook
      modal.addEventListener('click', function (event) {
        if (event.target.closest(CLOSE_SELECTOR)) closeModal();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeModal();
      });
    }
    /** InsCoder 2026-09-17 E + Mobile: the icon opens the footnote modal **/
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;

    var root = target.dataset && target.dataset.hp26Bb !== undefined
      ? target
      : target.querySelector(ROOT_SELECTOR);

    if (root) initSection(root);
    else initAll();
  });
})();
/** InsCoder 2026-09-17 E + HP 26 brand brief: award footnote (PC hover bubble / MB tap modal) **/
